import api from '@/app/modules/auth/api';

export default {
  namespaced: true,
  state: {
    accessToken: null,
    idToken: null,
    profile: null,
    isLoggedOn: false,
    tokenExpiresAt: null,
  },

  mutations: {
    setTokens(state, { accessToken, idToken, expiresIn }) {
      state.accessToken = accessToken;
      if (idToken) state.idToken = idToken;
      state.tokenExpiresAt = Date.now() + expiresIn * 1000;
      state.isLoggedOn = true;
    },
    setUser(state, user) {
      state.profile = user;
      if (user) localStorage.setItem('userProfileData', JSON.stringify(user));
    },
    clearAuth(state) {
      state.accessToken = null;
      state.idToken = null;
      state.profile = null;
      state.isLoggedOn = false;
      state.tokenExpiresAt = null;
    },
  },

  actions: {
    async exchange({ commit, dispatch }, { code, codeVerifier, redirectUri, clientId }) {
      const response = await api.exchange({ code, codeVerifier, redirectUri, clientId });
      commit('setTokens', response.data);
      await dispatch('loadUser');
    },
    async refresh({ commit }) {
      const response = await api.refresh();
      commit('setTokens', response.data);
    },
    async loadUser({ commit }) {
      try {
        const response = await api.getProfileData();
        commit('setUser', response.data);
      } catch {
        commit('setUser', null);
        commit('clearAuth');
      }
    },
    logout({ commit }) {
      commit('clearAuth');
      localStorage.removeItem('userProfileData');
    },
    async initAuth({ dispatch }) {
      try {
        await dispatch('refresh');
        await dispatch('loadUser');
      } catch {
        dispatch('logout');
      }
    },
  },

  getters: {
    isAuthenticated: (state) => !!state.accessToken,
    getUserProfile: (state) => state.profile,
    getAccessToken: (state) => state.accessToken,
  },
};
